import { render } from "./Vinks.vue?vue&type=template&id=e23db5fe&scoped=true"
import script from "./Vinks.vue?vue&type=script&lang=js"
export * from "./Vinks.vue?vue&type=script&lang=js"

import "./Vinks.vue?vue&type=style&index=0&id=e23db5fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23db5fe"]])

export default __exports__